export default __webpack_public_path__ + "static/BOM_TOUR_MAY22_NEWCASTLE_Desktop_1200x450_30213SA-6d9aba0a043666153b484b05f549dc70.jpg";